import { CustomContactFormContext } from '@frontend/create-contact-panel';
import { formatPhoneNumberWithoutCountryCode } from '@frontend/phone-numbers';

export const buildCreateContactContext = ({
  firstName,
  lastName,
  phoneNumber,
  locationId,
  onSave,
  onError,
}: {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  locationId?: string;
  onSave?: CustomContactFormContext['onSave'];
  onError?: CustomContactFormContext['onError'];
}): CustomContactFormContext => ({
  mode: 'create',
  person: {
    FirstName: firstName || undefined,
    LastName: lastName || undefined,
    MobilePhone: phoneNumber ? formatPhoneNumberWithoutCountryCode(phoneNumber) : undefined,
  },
  locationId,
  onSave,
  onError,
});
